import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BusinessManagment, PackageDto } from 'app/public/model/BusinessManagment';
import { Observable, share } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessManagmentService {
 
  constructor(private httpClient: HttpClient) { }
  getBusinessRoulettes(request: any): Observable<{ BusinessRoulettes: BusinessManagment[], TotalCount: number }> {
  return this.httpClient.post<{ BusinessRoulettes: BusinessManagment[], TotalCount: number }>('/manager', request).pipe(share());
}

getPackages(): Observable<PackageDto[]> {
  return this.httpClient.get<PackageDto[]>("/package");
}
}
